/* src/app/builder-screen-beta/template-selector/template-selector.component.scss */
.template-selector {
  padding: 24px;
  background: #fafafa;
  min-height: 100vh;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  border: 3px solid red !important;
  position: relative !important;
  z-index: 9999 !important;
}
.template-selector .debug-info {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px;
  margin: 8px 0;
  font-family: monospace;
  font-size: 12px;
}
.template-selector .debug-info {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px;
  margin: 8px 0;
  font-family: monospace;
  font-size: 12px;
}
.template-selector .template-selector-header {
  margin-bottom: 32px;
  text-align: center;
}
.template-selector .template-selector-header h2 {
  margin-bottom: 16px;
  color: #262626;
  font-weight: 600;
}
.template-selector .template-selector-header h2 i {
  margin-right: 12px;
  color: #1890ff;
}
.template-selector .template-selector-header p {
  color: #8c8c8c;
  font-size: 16px;
  max-width: 600px;
  margin: 0 auto;
}
.template-selector .template-selector-filters {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 32px;
  border: 1px solid #f0f0f0;
}
.template-selector .template-selector-filters nz-space {
  width: 100%;
  justify-content: center;
}
.template-selector .template-selector-filters .button-group {
  display: flex;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d9d9d9;
}
.template-selector .template-selector-filters .button-group button {
  border-radius: 0;
  border: none;
  border-right: 1px solid #d9d9d9;
}
.template-selector .template-selector-filters .button-group button:last-child {
  border-right: none;
}
.template-selector .template-selector-filters .button-group button:hover {
  border-color: #1890ff;
}
.template-selector .template-selector-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
.template-selector .template-selector-content .template-list-viewport {
  width: 100%;
}
.template-selector .template-selector-content .template-list-viewport .cdk-virtual-scroll-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.template-selector .template-selector-content .template-grid .template-card {
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}
.template-selector .template-selector-content .template-grid .template-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-color: #1890ff;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-head {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  color: white;
  border-bottom: none;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-head .ant-card-head-title {
  color: white;
  font-weight: 600;
  font-size: 16px;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-head .ant-card-extra {
  color: rgba(255, 255, 255, 0.8);
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-body {
  padding: 20px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-description {
  color: #595959;
  margin-bottom: 16px;
  line-height: 1.5;
  font-size: 14px;
  min-height: 40px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-category {
  margin-bottom: 16px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-category .ant-tag {
  border-radius: 16px;
  padding: 4px 12px;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-info {
  margin-bottom: 16px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-info .info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #8c8c8c;
  font-size: 13px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-info .info-item i {
  color: #1890ff;
  font-size: 14px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-info .info-item span {
  flex: 1;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-components {
  margin-bottom: 16px;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-components .ant-tag {
  border-radius: 12px;
  font-size: 11px;
  padding: 2px 8px;
  margin: 2px;
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #595959;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-dates {
  text-align: center;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
}
.template-selector .template-selector-content .template-grid .template-card .template-card-content .template-dates small {
  color: #8c8c8c;
  font-size: 11px;
  line-height: 1.4;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions {
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions li {
  border-right: 1px solid #f0f0f0;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions li:last-child {
  border-right: none;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions button {
  border: none;
  background: transparent;
  color: #595959;
  transition: all 0.2s ease;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions button:hover {
  color: #1890ff;
  background: rgba(24, 144, 255, 0.1);
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions button.ant-btn-primary {
  background: #1890ff;
  color: white;
}
.template-selector .template-selector-content .template-grid .template-card .ant-card-actions button.ant-btn-primary:hover {
  background: #40a9ff;
  color: white;
}
.template-preview .ant-descriptions {
  margin-bottom: 24px;
}
.template-preview .ant-collapse .ant-collapse-item .ant-collapse-header {
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 8px;
  padding: 12px 16px;
  font-weight: 500;
}
.template-preview .ant-collapse .ant-collapse-item .ant-collapse-header .ant-collapse-arrow {
  color: #1890ff;
}
.template-preview .ant-collapse .ant-collapse-item .ant-collapse-content .ant-collapse-content-box {
  padding: 16px;
  background: white;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
}
.template-preview .component-details .ant-descriptions-item-label {
  font-weight: 600;
  color: #262626;
}
.template-preview .component-details .ant-descriptions-item-content .ant-tag {
  border-radius: 12px;
  font-size: 11px;
  padding: 2px 8px;
}
@media (max-width: 768px) {
  .template-selector {
    padding: 16px;
  }
  .template-selector .template-selector-filters {
    padding: 16px;
  }
  .template-selector .template-selector-filters nz-space {
    flex-direction: column;
    align-items: stretch;
  }
  .template-selector .template-selector-filters nz-space > * {
    width: 100% !important;
    margin-bottom: 12px;
  }
  .template-selector .template-grid .ant-col {
    margin-bottom: 16px;
  }
}
@media (max-width: 480px) {
  .template-selector {
    padding: 12px;
  }
  .template-selector .template-selector-header h2 {
    font-size: 20px;
  }
  .template-selector .template-selector-header p {
    font-size: 14px;
  }
  .template-selector .template-card .ant-card-head .ant-card-head-title {
    font-size: 14px;
  }
  .template-selector .template-card .template-card-content .template-description {
    font-size: 13px;
  }
  .template-selector .template-card .template-card-content .info-item {
    font-size: 12px;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.template-card {
  animation: fadeInUp 0.6s ease-out;
}
.template-card.template-card-featured {
  border-color: #faad14;
  box-shadow: 0 4px 16px rgba(250, 173, 20, 0.2);
}
.template-card.template-card-featured .ant-card-head {
  background:
    linear-gradient(
      135deg,
      #faad14 0%,
      #f5222d 100%);
}
.template-card.template-card-new {
  border-color: #52c41a;
  box-shadow: 0 4px 16px rgba(82, 196, 26, 0.2);
}
.template-card.template-card-new .ant-card-head {
  background:
    linear-gradient(
      135deg,
      #52c41a 0%,
      #1890ff 100%);
}
.template-preview .ant-collapse {
  max-height: 400px;
  overflow-y: auto;
}
.template-preview .ant-collapse::-webkit-scrollbar {
  width: 6px;
}
.template-preview .ant-collapse::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.template-preview .ant-collapse::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.template-preview .ant-collapse::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.ant-tooltip .ant-tooltip-inner {
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 10px;
}
.ant-tag.ant-tag-blue {
  background: rgba(24, 144, 255, 0.1);
  border-color: #91d5ff;
  color: #1890ff;
}
.ant-tag.ant-tag-green {
  background: rgba(82, 196, 26, 0.1);
  border-color: #b7eb8f;
  color: #52c41a;
}
.ant-tag.ant-tag-orange {
  background: rgba(250, 173, 20, 0.1);
  border-color: #ffe58f;
  color: #faad14;
}
.ant-btn.ant-btn-text:hover {
  background: rgba(24, 144, 255, 0.1);
  border-color: transparent;
}
.ant-input:focus,
.ant-input:hover {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.ant-select:hover .ant-select-selector {
  border-color: #1890ff;
}
.ant-select.ant-select-focused .ant-select-selector {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
/*# sourceMappingURL=template-selector.component.css.map */
